export const KSA_QUESTIONNAIRE_NAME = 'ksa-onboarding-questionnaire';
export const ONBOARDING_QUESTIONNAIRE_NAME = 'onboarding';
